import { ErrorHandler, Provider } from '@angular/core';
import * as Sentry from '@sentry/angular';

import { environment } from 'environments/environment';

/** Create provider for Angular `ErrorHandler`.
 * Differs depending on whether Sentry is enabled or not.
 * Sentry is enabled by default (@see `environment.ts`).
 * Sentry is disabled in some lower environments; see their environment.ts files.
 * When enabled and env="production", we rely on Sentry and do not write unhandled errors to browser console.
 * @see https://github.com/getsentry/sentry-javascript/blob/master/packages/angular/src/errorhandler.ts
 * When disabled, use Angular's default ErrorHandler which writes errors to browser console.
 * @see https://angular.io/api/core/ErrorHandle
 */
export function getErrorHandlerProvider(): Provider {
  const logErrors = shouldLogErrorsToConsole();
  const provider = environment.thirdPartyConfigs.sentryEnabled
    ? // logErrors:true means "also write to browser console".
      { provide: ErrorHandler, useValue: Sentry.createErrorHandler({ logErrors }) }
    : { provide: ErrorHandler, useClass: ErrorHandler };
  return provider;
}

/** Whether Sentry should also log the unhandled errors it captures to the browser console. */
function shouldLogErrorsToConsole() {
  return environment.name !== 'deploy'; // Environment is "production", not just a production build
}
